import React from 'react';

import PropTypes from 'prop-types';

import { LinkButton } from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';
import Panel from '@adsk/alloy-react-panel';

type FiltersHeaderProps = {
  onClose?: () => void;
  title?: string;
  floatingPanel?: boolean;
  clearFilters?: () => void;
  hasFilters?: boolean;
};
/**
 * A filters panel header.
 * @returns {*}
 */
const FiltersHeader = React.forwardRef<HTMLDivElement, FiltersHeaderProps>(
  ({ onClose, title, floatingPanel, clearFilters, hasFilters }, ref) => {
    const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));
    return (
      <Panel.Header
        ref={ref}
        onClose={onClose}
        title={title}
        renderActions={() =>
          floatingPanel ? (
            <LinkButton
              onClick={clearFilters}
              disabled={!hasFilters}
              style={{
                marginRight: 10,
              }}
            >
              {T.translate('CLEAR_FILTERS')}
            </LinkButton>
          ) : null
        }
      />
    );
  },
);

FiltersHeader.displayName = 'FiltersHeader';

FiltersHeader.propTypes = {
  /** Callback to close the panel */
  onClose: PropTypes.func,
  /** Header title */
  title: PropTypes.string,
  /** Whether the panel is floating or not */
  floatingPanel: PropTypes.bool,
  /** Whether the panel has active filters or not */
  hasFilters: PropTypes.bool,
  /** Callback to clear filters */
  clearFilters: PropTypes.func,
};

export default FiltersHeader;
